import { Box, Container, Typography, useTheme } from "@mui/material";
import ComponentServices from "../../components/services";
import StartProject from "../../components/startProject";
import { Helmet } from "react-helmet-async";

export default function Services() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>
          Serviços de Climatização e Construção Civil | Clima Tropical Angola
        </title>

        <meta
          name="description"
          content="Conheça os serviços da Clima Tropical em Angola: climatização, instalação e manutenção de ar condicionado, serviços elétricos, construção civil, hidráulica, revestimentos e estruturas industriais."
        />

        <meta
          name="keywords"
          content="climatização Angola, ar condicionado Luanda, manutenção de ar condicionado, construção civil Angola, serviços elétricos, hidráulica, instalação elétrica, refrigeração, estruturas metálicas, Clima Tropical"
        />

        <link rel="canonical" href="https://climatropical.com/services" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Serviços de Climatização e Construção Civil | Clima Tropical Angola"
        />

        <meta
          property="og:description"
          content="Soluções profissionais em climatização, manutenção de ar condicionado, construção civil e serviços técnicos especializados em Angola."
        />

        <meta property="og:url" content="https://climatropical.com/services" />

        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta
          name="twitter:title"
          content="Serviços de Climatização e Construção Civil | Clima Tropical Angola"
        />

        <meta
          name="twitter:description"
          content="Descubra os serviços especializados da Clima Tropical para residências, empresas e indústrias em Angola."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
          minHeight: "100vh",
        }}
      >
        {/* Hero Section */}
        <Box
          sx={{
            background: `linear-gradient(130deg, ${theme.palette.primary.main} 30%, ${theme.palette.info.main} 170%)`,
            color: "white",
            py: { xs: 8, md: 12 },
            mb: 8,
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ maxWidth: "800px" }}>
              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: "bold",
                  mb: 3,
                  color: theme.palette.info.light,
                }}
              >
                Nossos Serviços
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  opacity: 0.9,
                  lineHeight: 1.6,
                }}
              >
                Oferecemos soluções completas de climatização, construção civil
                e serviços especializados. Nossa equipe está pronta para
                garantir conforto, segurança e eficiência em qualquer ambiente.
              </Typography>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="lg">
          {/* Service Selection */}
          <Box sx={{ mb: 8 }}>
            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                color: theme.palette.primary.main,
                mb: 6,
              }}
            >
              Escolha o Serviço Desejado
            </Typography>

            <ComponentServices />
            <StartProject />
          </Box>
        </Container>
      </Box>
    </>
  );
}
